// measurementsStore.js — per-user, per-chart-context "Measure" tool persistence (Supabase
// `chart_measurements`, migration 0006). Mirrors drawingsStore.js/followStore.js: wraps the
// existing anon supabaseClient; the front end reads/writes only its own rows (RLS:
// chart_measurements_self_all, user_id = auth.uid()).
//
// Unlike chart_drawings (a LIST of horizontal lines), this is ONE row per
// (user_id, symbol, context) — a fresh measurement overwrites the last one, matching the
// tool's actual UX (single active measurement, not a saved list). Syncs across devices for
// the same signed-in user — deliberately NOT localStorage.
import { supabase } from "./supabaseClient";

// SELECT the saved measurement for this user + symbol + context, or null if none exists.
// Throws on error (callers do NOT fall back silently — a missing relation / permission
// error must surface, same convention as drawingsStore.js).
export async function fetchMeasurement(userId, symbol, context) {
  const { data, error } = await supabase
    .from("chart_measurements")
    .select("time1, price1, time2, price2")
    .eq("user_id", userId)
    .eq("symbol", symbol)
    .eq("context", context)
    .maybeSingle();
  if (error) throw error;
  return data ?? null;
}

// Upsert the current measurement — overwrites any prior one for this symbol/context.
export async function saveMeasurement(userId, symbol, context, { time1, price1, time2, price2 }) {
  const { error } = await supabase
    .from("chart_measurements")
    .upsert(
      { user_id: userId, symbol, context, time1, price1, time2, price2 },
      { onConflict: "user_id,symbol,context" }
    );
  if (error) throw error;
}

// Remove the saved measurement for this symbol/context.
export async function deleteMeasurement(userId, symbol, context) {
  const { error } = await supabase
    .from("chart_measurements")
    .delete()
    .eq("user_id", userId)
    .eq("symbol", symbol)
    .eq("context", context);
  if (error) throw error;
}
